export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "lorem": {
    "title": "Lorem Ipsum 生成器",
    "subtitle": "生成设计、开发和内容原型所需的占位文本。",
    "privacy": "100% 本地处理",
    "style": "文本风格",
    "styleLatin": "拉丁文",
    "styleChinese": "中文",
    "styleBusiness": "商务英语",
    "styleTech": "技术文档",
    "paragraphs": "段落数",
    "sentences": "每段句数",
    "startWithLorem": "以 Lorem Ipsum 开头",
    "wrapHtml": "用 HTML <p> 包裹",
    "generate": "生成",
    "statWords": "字数",
    "statChars": "字符数",
    "statSentences": "句子数",
    "statParagraphs": "段落数",
    "emptyHint": "在上方配置参数并点击生成按钮创建占位文本"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有文本生成均在您的浏览器本地完成。任何数据都不会被上传到服务器。"
    },
    "guide": {
      "title": "如何使用 Lorem Ipsum 生成器",
      "description": "为设计、开发和内容原型生成占位文本。",
      "steps": [
        {
          "title": "配置设置",
          "description": "选择段落数、每段句子数和单词风格。选项包括标准 Lorem Ipsum、英语单词或自定义词汇。"
        },
        {
          "title": "生成文本",
          "description": "点击生成按钮即时创建占位文本。输出格式带有适当的段落分隔。"
        },
        {
          "title": "复制或下载",
          "description": "将生成的文本复制到剪贴板，或将其下载为 .txt 或 .html 文件，以便在设计工具、CMS 平台或代码编辑器中使用。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "可自定义段落和句子数量",
        "多种词汇模式：拉丁语、英语、自定义",
        "HTML 和纯文本输出格式",
        "一键复制和文件下载",
        "即时生成，零延迟",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的数据会被发送到服务器吗？",
          "answer": "不会。所有文本生成均在您的浏览器内完成。没有任何内容被传输或存储到外部。"
        },
        {
          "question": "什么是 Lorem Ipsum？",
          "answer": "Lorem Ipsum 是自 16 世纪以来出版和设计领域使用的经典占位文本。它模仿自然语言模式，但不会用有意义的内容分散读者的注意力。"
        },
        {
          "question": "可以在商业项目中使用生成的文本吗？",
          "answer": "可以。生成的占位文本可以免费用于任何项目，无论是商业还是个人用途。在发布最终产品之前，请将其替换为真实内容。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "大小写转换器",
          "url": "/text/case-converter",
          "description": "在大小写、小写、camelCase、snake_case 等之间转换文本。"
        },
        {
          "name": "Markdown 编辑器",
          "url": "/text/markdown-editor",
          "description": "使用语法高亮实时编写和预览 Markdown。"
        },
        {
          "name": "密码生成器",
          "url": "/generator/password-generator",
          "description": "生成强安全密码和易记的密码短语。"
        }
      ]
    }
  }
};
